import { RulesetList } from "./RulesetList";

export default RulesetList;
